import styled from 'styled-components';

export const Container = styled.div`
  max-width: 520px;
  text-align: center;
  margin: 0 auto;
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.configs.tertiaryBox.mainFontColor};
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  margin-bottom: 8px;
`;

export const SubText = styled.div`
  color: ${({ theme }) => theme.configs.tertiaryBox.mainFontColor};
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 24px;
`;
